import Emitter from "./Emitter";

export default class RequestRegister extends Emitter {
    constructor(gb) {
        super(gb);
    }

    _default() {
        this.emitTop({ wpgaction: "register" });
        this.emitParent({ wpgaction: "register.parent" });
        this.emitiOS({ wpgaction: "register" });
    }
}
